export enum Sizes {
  'CONTAINER.SM' = 'container.sm',
  'CONTAINER.MD' = 'container.md',
  'CONTAINER.LG' = 'container.lg',
  'CONTAINER.XL' = 'container.xl',
  '3XS' = '3xs',
  '2XS' = '2xs',
  'XS' = 'xs',
  'SM' = 'sm',
  'MD' = 'md',
  'LG' = 'lg',
  'XL' = 'xl',
  '2XL' = '2xl',
  '3XL' = '3xl',
  '4XL' = '4xl',
  '5XL' = '5xl',
  '6XL' = '6xl',
  '7XL' = '7xl',
  'PROSE' = 'prose',
  'FULL' = 'full',
  'MAX' = 'max',
  'MIN' = 'min',
}
